import { render, staticRenderFns } from "./FormInputGroupFormElements.vue?vue&type=template&id=06e35bba&"
import script from "./FormInputGroupFormElements.vue?vue&type=script&lang=js&"
export * from "./FormInputGroupFormElements.vue?vue&type=script&lang=js&"
import style0 from "./FormInputGroupFormElements.vue?vue&type=style&index=0&id=06e35bba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports